import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useActions } from 'hooks/useActions';
import { ContentContainer, ChallengeLabel, SectionContainer } from './styles';
import * as actions from './actions';
import { Container, Wrapper } from 'components/Layout/Layout';
import CommunityComments from 'components/CommunityComments/CommunityComments';
import CommunityPageImageAndDescription from 'components/CommunityPageImageAndDescription/CommunityPageImageAndDescription';

export default function ExerciseLandingPage() {
  const { id } = useParams();

  const { error, selectedExercise } = useSelector((state) => state.ExerciseLandingPageReducer);

  const { getExercise, setExerciseRating } = useActions(actions);

  useEffect(() => {
    if (id) getExercise(id);
  }, [getExercise, id]);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  const setItemRating = (challengeRating) => {
    setExerciseRating(challengeRating, id);
  };

  return (
    <Wrapper color="transparent">
      <CommunityPageImageAndDescription
        selectedItem={selectedExercise}
        setItemRating={setItemRating}
        startUrl={`/exercise/${id}`}
      />
      <Container column>
        <ContentContainer>
          <SectionContainer>
            <ChallengeLabel>Discussion</ChallengeLabel>
            <CommunityComments testId={id} />
          </SectionContainer>
        </ContentContainer>
      </Container>
    </Wrapper>
  );
}
